module.exports = __webpack_public_path__ + "img/dp-csr.1b8fd4ef.jpg";